import { IFormTextareaProps, FormTextarea } from '@gcl/react-core';
import './FormTextareaWithMaxLength.scss';

interface IFormTextareaWithMaxLengthProps extends IFormTextareaProps {
  max: number;
  defaultNumOfLines?: number;
}

export const FormTextareaWithMaxLength = ({
  max,
  id,
  formFieldMethods,
  rules,
  className,
  defaultNumOfLines = 3,
  ...props
}: IFormTextareaWithMaxLengthProps) => {
  const text: string | undefined = formFieldMethods.watch(id);

  let newRules = rules || {};
  newRules = {
    ...(rules || {}),
    maxLength: {
      value: max,
      message: `Maximum ${max} characters`,
    },
  };

  return (
    <div
      className={`${className} gcl-gems-form-text-area-with-max-length-container`}
      style={{ minHeight: `${defaultNumOfLines * 25}px` }}
    >
      <FormTextarea formFieldMethods={formFieldMethods} id={id} {...props} rules={newRules} />
      <span>
        {max - (text?.length ?? 0)} characters remaining ({max} maximum)
      </span>
    </div>
  );
};
